import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from "axios"
import { BASE_API, StorageKey } from "../constants"
import {isNullOrUndefined} from "../utils"

const http = axios.create({
  baseURL: BASE_API,
  headers: {
    'Authorization': localStorage.getItem(StorageKey.TOKEN) == null ? `` : `Bearer ${localStorage.getItem(StorageKey.TOKEN)}`,
    'authorization': localStorage.getItem(StorageKey.TOKEN) == null ? `` : `Bearer ${localStorage.getItem(StorageKey.TOKEN)}`,
    'Content-Type': 'application/json'
  }
})

const pHttp = axios.create({
  baseURL: BASE_API,
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(StorageKey.TOKEN)}`,
    'authorization': `Bearer ${localStorage.getItem(StorageKey.TOKEN)}`,
    'Content-Type': 'application/json'
  }
})

const responseInterceptors = {
  onSuccess: (response: AxiosResponse) => {
    // if (response.data && response.headers['content-type'] === 'application/json') {
    //   response.data = camelizeKeys(response.data)
    // }


    return response.data ? response.data : response
  },
  onError: (error: AxiosError) => {
    console.log("!!! INTERCEPTOR ERROR !!!", error)
    const data: any = error.response?.data
    if (!isNullOrUndefined(data) && !isNullOrUndefined(data.message)) {
      console.log(data.message)
      if (data.message == "Смена токена" || data.message == "Пользователь не авторизован" || data.message == "Ошибка авторизации") {
        // localStorage.removeItem(StorageKey.TOKEN)
        // localStorage.removeItem(StorageKey.USER)
        // localStorage.removeItem(StorageKey.GOODS_USER)
        // localStorage.removeItem(StorageKey.GOODS_AUTHED)
        // window.location.href = "/auth"
        // window.location.reload()

        let cnt = localStorage.getItem("nx_plus_auth_cntx")
        if (cnt != null) {
          if (parseInt(cnt) > 1) {
            localStorage.removeItem("nx_plus_auth_cntx")
            localStorage.removeItem(StorageKey.TOKEN)
            localStorage.removeItem(StorageKey.USER)
            localStorage.removeItem(StorageKey.GOODS_USER)
            localStorage.removeItem(StorageKey.GOODS_AUTHED)
            window.location.href = "/auth"
          } else {
            localStorage.setItem("nx_plus_auth_cntx", `${parseInt(cnt) + 1}`)
            setTimeout(() => {
              window.location.reload()
            }, 200)
          }
        } else {
          localStorage.setItem("nx_plus_auth_cntx", "1")
          setTimeout(() => {
            window.location.reload()
          }, 200)
        }
      }

      
    }
    return Promise.resolve(error)
  }
}


const requestInterceptors = {
  onSuccess: (config: InternalAxiosRequestConfig) => {
    // config.params = decamelizeKeys(config.params)
    // if (config.data && config.headers['Content-Type'] === 'application/json') {
    //   config.data = decamelizeKeys(config.data)
    // }


    return config
  },
  onError: (error: Error) => {
    console.log("!!! INTERCEPTOR REQ ERROR !!!", error)
    return Promise.reject(error)
  }
}


http.interceptors.request.use(requestInterceptors.onSuccess, requestInterceptors.onError)
http.interceptors.response.use(responseInterceptors.onSuccess, responseInterceptors.onError)

pHttp.interceptors.request.use(requestInterceptors.onSuccess, requestInterceptors.onError)
pHttp.interceptors.response.use(responseInterceptors.onSuccess, responseInterceptors.onError)

export { http, pHttp }

export const buildParams = (map: any) => {
  let query = "";
  for (let key in map) {
    if (query == "") {
      query = `?${key}=${map[key]}`;
    } else {
      query += `&${key}=${map[key]}`;
    }
  }
  return query;
}